import logger from "core/logger";

export class ConsoleLoggerPreRenderStep {
    run(instruction, next) {
        logger.debug("PRE RENDER STEP", instruction);
        return next();
    }
}

